// RICS Home Surveys (Levels 1-3) — survey only, no valuations.

export const HS_LEVELS = [
  {
    level: "1",
    name: "RICS Home Survey — Level 1",
    formerly: "formerly the Condition Report",
    tagline: "A clear snapshot of condition.",
    bestFor:
      "Modern, conventionally built homes in apparently good condition — newer estates and recently updated properties.",
    includes: [
      "Visual inspection of all accessible areas",
      "Traffic-light condition ratings for every element",
      "Summary of risks to the building, people and grounds",
      "Urgent defects and legal matters flagged for your conveyancer",
    ],
    excludes: ["Repair and maintenance advice", "Market valuation"],
    depth: "Concise",
  },
  {
    level: "2",
    name: "RICS Home Survey — Level 2",
    formerly: "formerly the HomeBuyer Report",
    tagline: "The popular choice for most homes.",
    bestFor:
      "Conventional houses, bungalows and flats in reasonable condition — the right level for the majority of Lincolnshire homes.",
    includes: [
      "Everything in Level 1, inspected in greater depth",
      "Closer inspection of the roof space and drainage chamber",
      "Advice on defects, repairs and ongoing maintenance",
      "What to ask your legal adviser before exchange",
    ],
    excludes: ["Market valuation (offered as survey-only)"],
    depth: "Intermediate",
    popular: true,
  },
  {
    level: "3",
    name: "RICS Home Survey — Level 3",
    formerly: "formerly the Building Survey",
    tagline: "The deepest level of inspection.",
    bestFor:
      "Older, altered, extended, larger or unusual properties — period homes, listed buildings and anything you suspect needs work.",
    includes: [
      "Thorough, detailed inspection of the property's fabric",
      "Analysis of defects: cause, repair options and consequences of not repairing",
      "Estimated repair costs and timescales where practicable and agreed",
      "Guidance on how the property was built and how it performs",
    ],
    excludes: ["Market valuation"],
    depth: "Comprehensive",
  },
];

export const HS_FAQS = [
  {
    q: "Which RICS survey level do I need?",
    a: "As a rule of thumb: Level 1 suits modern, conventional homes in apparently good order; Level 2 suits most conventional houses, bungalows and flats in reasonable condition and is the most commonly chosen; Level 3 is for older, altered, extended or unusual properties — which covers much of Lincolnshire's period stock in towns like Louth, Horncastle and uphill Lincoln. If you're unsure, send me the listing and I'll recommend the right level honestly — including when the cheaper option is the correct one.",
  },
  {
    q: "Do your RICS home surveys include a valuation?",
    a: "No — I provide RICS home surveys on a survey-only basis and do not carry out valuations. Level 2 is offered in its survey-only format, which contains the full inspection and advice without the market valuation. If you need a market valuation or a mortgage valuation, that must come from an RICS Registered Valuer — typically arranged by your lender.",
  },
  {
    q: "What's the difference between Level 2 and Level 3?",
    a: "Depth and detail. Level 2 is a thorough inspection with condition ratings and advice on repairs and maintenance, designed for conventional properties in reasonable condition. Level 3 examines the fabric of the building in far greater detail — analysing the cause of defects, setting out repair options and their consequences, and where agreed, estimating repair costs and timescales. For a 1990s estate house in Grantham or Bourne, Level 2 is usually right; for a Victorian villa in Lincoln or a Wolds farmhouse near Louth, Level 3 earns its fee.",
  },
  {
    q: "Isn't the mortgage valuation enough?",
    a: "No — a mortgage valuation exists to protect the lender's loan, not you. It is often brief, sometimes done without visiting the property at all, and tells you almost nothing about condition. An RICS home survey is a genuine physical inspection of the property carried out for you, the buyer.",
  },
  {
    q: "How long does the survey and report take?",
    a: "Inspection time depends on the level and the property — from an hour or two for a Level 1 to half a day or more for a Level 3 on a large period house. Written reports are delivered within 3–5 working days, and every survey includes a follow-up call to walk through the findings in plain English.",
  },
  {
    q: "Which areas do you cover for RICS home surveys?",
    a: "The whole of Lincolnshire — including Lincoln, Grantham, Sleaford, Boston, Spalding, Louth, Horncastle, Woodhall Spa, Coningsby, Tattershall, Bourne, Market Deeping, Holbeach, Skegness, Market Rasen, Caistor, Alford, Spilsby, Wragby and Newark-on-Trent — plus the surrounding villages. Inspection slots are usually available within the week.",
  },
  {
    q: "Can you still help if the property turns out to need specialist investigation?",
    a: "Yes — where a survey identifies something needing further investigation (structural movement, drains, timber decay), the report says so clearly and explains what to commission and why, before you exchange. You'll never be left with a vague 'seek further advice' and nothing more.",
  },
];
